import {
  Wizard,
  useWizardPage,
  Text,
  Stack,
  Title
} from '@efast_public/fjd-component-library';
import './CheckList.css';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
interface Checkboxes {
  fitConnect: boolean;
  keys: boolean;
}
function CheckList(): ReactElement {
  const { t } = useTranslation();

  useWizardPage({
    headline: (state) =>
      `Schritt ${state.currentPageIndex + 1} von ${state.pagesLength}`,
    primaryButtonLabel: t('configAssistent.checkList.primaryButton'),
    isFormValid: true
  });

  return (
    <Wizard.Page>
      <Stack spacing="m">
        <Title level={2} visualLevel={6}>
          {t('configAssistent.checkList.headline')}
        </Title>
        <Text>{t('configAssistent.checkList.descriptionText')}</Text>
      </Stack>
    </Wizard.Page>
  );
}

export default CheckList;
